<template>
<div class="container admin">
   <div class="header card">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>权限管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path: '/role/list'}">角色管理</el-breadcrumb-item>
        <el-breadcrumb-item>权限分配</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">权限分配</h2>
        </div>
        <div class="right">
           <el-button @click="handleClose">取 消</el-button>
          <el-button class="button" type="primary" @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <el-tree
      :data="rules"
       default-expand-all
       node-key="id" show-checkbox
       ref="tree"
       highlight-current
       :props="defaultProps"
       @check="check"
       >
      </el-tree>
    </div>
</div>

</template>

<script>
import { adminRuleList,adminRoleUpdate, adminRoleOne} from '@/api/admin'

export default {
    name: 'dashboard',
    data() {
      return {
        role: {},
        rules:[],
        checkAll: false,
        defaultProps: {
          children: 'children',
          label: 'title',
        },
        selections:''
      }
    },
    created() {
      this.fetchAdminRuleList()
    },
    methods: {
      // 管理权限列表查询
      fetchAdminRuleList() {
        adminRuleList().then(res => {
          this.rules = res.list

          this.fetchRoleInfo()
        })
      },
      // 角色详情查询
      fetchRoleInfo() {
        adminRoleOne({id: this.$route.query.roleId}).then(res => {
          this.role = res
          if (res.rules) {
            const rules = this.computeSelections(this.rules, res.rules.split(',').map(v => Number(v)))
            this.$refs.tree.setCheckedKeys(rules)
          }
        })
      },
      check(item,obj) {
        this.selections = String(obj.checkedKeys.concat(obj.halfCheckedKeys))
      },
      // 权限编辑保存
      handleSubmit() {
        adminRoleUpdate({id: this.$route.query.roleId, rules: this.selections}).then(res => {
          this.handleClose()
        })
      },
      handleClose() {
        this.$router.go(-1)
      },
      // 层级依赖计算
      computeSelections(rules, selections) {
        const results = []
        rules.forEach(item => {
          if (item.children && item.children.length) {
            results.push(...this.computeSelections(item.children, selections))
          } else {
            if (selections.includes(item.id)) {
              results.push(item.id)
            }
          }
        })
        return results
      }
    }
};
</script>


<style scoped lang="less">
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #FFF;
    border: 1px solid #EBEEF5;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {

    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
